import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmProjectsDirectoryRoute: InvariantJiraRoute = {
	name: 'csm-projects-directory',
	path: '/jira/customer-service-management/projects',
	exact: true,
	query: ['csm_onboarding?', 'types?'],
};
